/**
 * Save and restore form drafts across page reloads (e.g., session expiry).
 */

export function saveDraft(key: string, data: Record<string, any>): void {
    try {
        localStorage.setItem(`draft:${key}`, JSON.stringify(data));
    } catch {
        // localStorage full or unavailable
    }
}

export function loadDraft<T = Record<string, any>>(key: string): T | null {
    try {
        const raw = localStorage.getItem(`draft:${key}`);
        if (!raw) return null;
        return JSON.parse(raw) as T;
    } catch {
        return null;
    }
}

export function clearDraft(key: string): void {
    localStorage.removeItem(`draft:${key}`);
}
